import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNdd75 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD_75: Record<
  Exclude<PageIdWoofzNdd75, PageIdWoofzNdd75.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NDD_75]: {
    id: PageId.SUBSCRIPTIONS_NDD_75,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_NDD_75]: {
    id: PageId.CHAT_UPSELL_NDD_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NDD_75]: {
    id: PageId.UPSELL_NDD_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NDD_75]: {
    id: PageId.DOWNLOAD_NDD_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
